module.exports = __webpack_public_path__ + "img/Lead Management.a58f1fe9.svg";